import { NgModule } from '@angular/core';
import { ConfirmationModalComponent } from '../components/confirmation-modal/confirmation-modal.component';
import { CommonModule, DatePipe } from '@angular/common';
import { DialogModule } from '@angular/cdk/dialog';
import { ReactiveFormsModule } from '@angular/forms';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { FormModalComponent } from '../components/form-modal/form-modal.component';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  declarations: [
    ConfirmationModalComponent,
  ],
  imports: [
    CommonModule,
    DialogModule,
    ReactiveFormsModule,
    AngularSvgIconModule,
    TooltipModule,
    TranslateModule,
    FormModalComponent
  ],
  exports: [
    ConfirmationModalComponent,
    FormModalComponent,
    CommonModule,
    DialogModule,
    ReactiveFormsModule,
    AngularSvgIconModule,
    TooltipModule,
    TranslateModule
  ],
  providers: [
    DatePipe
  ]
})
export class CoreModule {
}
